import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './ConversationPopup.module.scss';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  IconButton,
  Typography,
} from '@material-ui/core';
import ImageSlider from '../ImageSlider/ImageSlider';
import {
  AblumIcon,
  BluePlayArrowIcon,
  RestartIcon,
} from 'app/assets/images/icons';
import { useModal } from 'app/context/Modal';
import TweetCardContent from '../TweetCardContent';
import UserInfo from '../UserInfo';
import { _t } from 'app/utils/i18n';
import InfiniteScroll from 'react-infinite-scroll-component';
import { apiRoutes } from 'posts/utils/apiRoutes';
import { useMutation, useQuery } from 'react-query';
// import { getCommentsDataList, getRegrabReplies } from 'posts/Requests';
import Loader from '../Loader';
import { toast } from 'react-toastify';
import { storeInfluencerInstagram } from 'influencers/Requests';
import { useHistory } from 'react-router-dom';
import { path } from 'app/utils/path';
import AudioTextRow from '../AudioTextRow';
type TResponse = {
  total_record: number;
  total_page: number;
  next_page: number;
};
interface Props {
  commentsConversation: { postData: any };
  isOpen: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  getCommentsDataList?: any;
  getRegrabReplies?: any;
  withAudioRow?: boolean;
  openModalToAddInfluencer?: (url: string, username: string) => void;
}

const ConversationPopup: FunctionComponent<Props> = ({
  commentsConversation,
  isOpen,
  handleClose,
  handleOpen,
  getCommentsDataList,
  getRegrabReplies,
  withAudioRow,
  openModalToAddInfluencer,
}) => {
  const postData = commentsConversation?.postData;
  const modal = useModal();
  const [commentData, setCommentData] = useState<any[]>([]);
  const [expanded, setExpanded] = useState<number | false>(false);
  const [page, setPage] = useState<number>(1);
  const [responseRecords, setResponseRecords] = useState<TResponse>({
    total_record: 0,
    total_page: 0,
    next_page: 0,
  });
  const history = useHistory();
  const { isLoading } = useQuery(
    [
      'getCommentsReliesData',
      {
        body: {
          post_id: postData?.id,
          limit: 10,
          page: page,
        },
      },
    ],
    getCommentsDataList,
    {
      onSuccess: (res: any) => {
        setCommentData((pref: any[]) => {
          const newData = res?.payload?.records.filter(
            (item: any) =>
              !pref.some((prevItem: any) => prevItem.id === item.id),
          );
          return [...pref, ...newData];
        });
        // setCommentData((pref: any) => [...pref, ...res?.payload?.records]);
        setResponseRecords({
          total_page: res?.payload?.total_page,
          total_record: res?.payload?.total_record,
          next_page: res?.payload?.next_page,
        });
      },
      staleTime: 0,
      refetchOnMount: true,
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnReconnect: true,
    },
  );
  const { mutateAsync: addInfluncerInstagramMutateAsync } = useMutation(
    storeInfluencerInstagram,
    {
      onSuccess: (rec: any) => {
        modal.hide();
        history.push(
          `${path.influencers.UN_ANALYZED_INFLUENCER_DETAILS_URI}/${rec?.id}`,
        );
        toast.success(<span>{_t('influencers:added_influencer')}</span>);
      },
      onError: (err: any) => {
        modal.hide();
        toast.error(<span>{err?.response?.data?.message}</span>);
      },
    },
  );

  const RepliesConversationsMutation = useMutation(getRegrabReplies, {
    onSuccess: () => {
      modal.show({
        onOkText: _t('ok'),
        message: `${_t('basic:working_on_grabbing')} ${_t('posts:reply_conversation')} ${_t(
          'basic:you_will_be_notified',
        )}`,
        onOk: () => {
          modal.hide();
        },
        hideCancel: true,
      });
      handleOpen();
    },
    onError: (err: any) => {
      toast.error(<span>{err?.response?.data?.message}</span>);
      handleOpen();
    },
  });
  const handleChange =
    (panel: number) => (_: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  const fetchMoreData = () => {
    if (responseRecords.next_page > page) setPage(page + 1);
  };

  return (
    <div
      className={`${styles.ConversationPopupWrapper} ${!isOpen ? styles.Hidden : ''}`}
      onClick={(e) => {
        handleClose();
        e.preventDefault();
      }}
    >
      <Grid
        container
        spacing={0}
        className={styles.ConversationPopup}
        onClick={(e) => e.stopPropagation()}
      >
        <Grid item sm={6} className={styles.ConversationPopup__MediaBox}>
          {!!postData?.attachments?.length ? (
            <div style={{ position: 'relative' }}>
              <ImageSlider
                imageUrls={postData?.attachments}
                conversationsPopup
              />
            </div>
          ) : (
            <div className={styles.defaultImg}>
              <AblumIcon />
            </div>
          )}
        </Grid>
        <Grid
          item
          sm={6}
          className={styles.ConversationPopup__PostContentBox}
          id="scrollableDiv"
        >
          <TweetCardContent
            parentTweetData={postData}
            isInstagram
            isQuote
            hideImg
            borderBottom
            withAudioRow={withAudioRow}
          />

          <div className={styles.commentsWrapper}>
            {isLoading ? (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Loader />
              </div>
            ) : (
              <InfiniteScroll
                dataLength={commentData.length}
                next={fetchMoreData}
                hasMore={responseRecords.next_page > page}
                scrollableTarget="scrollableDiv"
                endMessage={
                  <p className={styles.textCenter}>
                    <b>
                      {commentData?.length > 10
                        ? _t('topics:no_more_items')
                        : ''}
                    </b>
                  </p>
                }
                loader={
                  <h4 className={styles.textCenter}>
                    {!commentData?.length ? ' ' : _t('basic:loading')}
                  </h4>
                }
                style={{ overflowX: 'hidden' }}
              >
                {commentData?.map((comment: any) => (
                  <div className={styles.commentList}>
                    <div className={styles.commentRow}>
                      <UserInfo
                        data={comment}
                        withActionRow
                        key={comment?.id}
                        regrabMutation={RepliesConversationsMutation}
                        addInfluncerMutateAsync={
                          addInfluncerInstagramMutateAsync
                        }
                        openModalToAddInfluencer={(url, username) =>
                          openModalToAddInfluencer?.(url,username)
                        }
                      />
                    </div>
                    <div className={styles.repliesList}>
                      <div style={{ marginBottom: '10px' }}>
                        <Accordion
                          expanded={expanded === comment?.id}
                          onChange={handleChange(comment?.id) as () => void}
                        >
                          <AccordionSummary
                            aria-controls={`${comment?.id}-content`}
                            id={`${comment?.id}-header`}
                          >
                            <Typography>
                              <ViewHideReplies
                                isView={comment?.id !== expanded}
                                repliesCount={comment?.replies_count}
                              />
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                            {comment?.replies?.map((reply: any) => (
                              <UserInfo data={reply} withActionRow />
                            ))}
                          </AccordionDetails>
                        </Accordion>
                      </div>
                    </div>
                  </div>
                ))}
              </InfiniteScroll>
            )}
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default ConversationPopup;
const ViewHideReplies = ({
  isView,
  repliesCount,
}: {
  isView: boolean;
  repliesCount: number;
}) =>
  repliesCount > 0 ? (
    <div className={styles.ViewHideReplies}>
      <div className={styles.ViewHideReplies__borderStart}></div>
      <div>
        {isView
          ? `${_t('posts:view_replies')} (${repliesCount})`
          : _t('posts:hide_replies')}
      </div>
    </div>
  ) : (
    <></>
  );
